import { createGate } from "effector-react";
import { createEffect, createEvent, createStore, sample } from "effector";

import * as api from "src/shared/api";
import { formatDate } from "../../../lib";

export type Report = {
  address: string;
  author: number;
  comment: string;
  datetime: string;
  description: string;
  fake: boolean;
  finish: boolean;
  id: number;
  lat: number;
  lng: number;
  new: boolean;
  phone: string | null;
  region: number;
  grouped_date?: string;
  time?: string;
  status: {
    name: string;
    color: string;
    icon: string;
  };
};

export type Media = { type: "video" | "photo"; src: string; media_url: string };

export const HistoryGate = createGate("history gate");

export const selectReport = createEvent<Report>("select report");

export const $selectedReport = createStore<Report | null>(null)
  .on(selectReport, (_, selectedReport) => selectedReport)
  .reset(HistoryGate.close);

export const $reportMedia = createStore<Media[] | null>(null).reset(
  HistoryGate.close
);

export const $reports = createStore<Report[]>([]);

export const fetchReportsFx = createEffect<unknown, Report[]>(async () => {
  const reports = await api.get("reports/");
  return await reports.data;
});

const fetchReportMediaFx = createEffect<number, Media[]>(async (id: number) => {
  const media = await api.get(`reports/${id}/media/`);
  return await media.data.files.map((media: Record<string, any>) => ({
    ...media,
    media_url: media.url,
  }));
});

sample({
  clock: HistoryGate.open,
  target: [fetchReportsFx],
});

sample({
  source: fetchReportsFx.doneData,
  fn: (reports: Report[]): Report[] =>
    reports.map((report) => ({
      ...report,
      datetime: new Date(report.datetime).toLocaleDateString(),
      time: new Date(report.datetime).toLocaleTimeString(),
      grouped_date: formatDate(new Date(report.datetime), "."),
    })),
  target: $reports,
});

sample({
  clock: $selectedReport,
  fn: (clck): number => {
    if (clck) return clck.id;
    return 1;
  },
  target: fetchReportMediaFx,
});

sample({
  source: fetchReportMediaFx.doneData,
  target: $reportMedia,
});
